import { render } from "./service_dashboard.html?vue&type=template&id=48480fce&external"
import script from "./service_dashboard.js?vue&type=script&lang=js&external"
export * from "./service_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__